import {EventData} from 'utils/hooks/useTrackEvent/types';

export interface SyncRequest {
  body: string;
  url: string;
}

export function requestToEventData({body, url}: SyncRequest): EventData {
  const requestType = getRequestType(url);
  const activityId = getActivityId({body, url}, requestType);

  enum AttributeByType {
    composition = 'composition_id',
    question = 'question_attempt_id',
    pedagogicalContent = 'pedagogical_content_id',
  }

  const eventData: EventData = {
    [requestType]: {
      [AttributeByType[requestType]]: activityId,
    },
  };

  return eventData;
}

function getRequestType(urlPath: string) {
  if (urlPath?.includes('compositions')) {
    return 'composition';
  }
  if (urlPath?.includes('question')) {
    return 'question';
  }
  if (urlPath?.includes('pedagogical')) {
    return 'pedagogicalContent';
  }

  return '';
}

function getActivityId({body, url}: SyncRequest, requestType: string) {
  let activityId = '';

  if (requestType === 'question') {
    const requestBody = JSON.parse(body);
    activityId = requestBody?.question;
  } else {
    const urlSegments = new URL(url).pathname.split('/').filter(Boolean);
    const urlId = urlSegments.find((segment) => /^\d+$/.test(segment));
    activityId = urlId ?? '';
  }

  return activityId;
}
